module.exports = __webpack_public_path__ + "img/doc.99038035.svg";